import PublicGoodsNetworkIcon from "./icons/PublicGoodsNetwork.svg";
export let ChainId = /*#__PURE__*/function (ChainId) {
  ChainId[ChainId["MAINNET"] = 1] = "MAINNET";
  ChainId[ChainId["GOERLI_CHAIN_ID"] = 5] = "GOERLI_CHAIN_ID";
  ChainId[ChainId["OPTIMISM_MAINNET_CHAIN_ID"] = 10] = "OPTIMISM_MAINNET_CHAIN_ID";
  ChainId[ChainId["FANTOM_MAINNET_CHAIN_ID"] = 250] = "FANTOM_MAINNET_CHAIN_ID";
  ChainId[ChainId["FANTOM_TESTNET_CHAIN_ID"] = 4002] = "FANTOM_TESTNET_CHAIN_ID";
  ChainId[ChainId["PGN"] = 424] = "PGN";
  ChainId[ChainId["PGN_TESTNET"] = 58008] = "PGN_TESTNET";
  ChainId[ChainId["ARBITRUM"] = 42161] = "ARBITRUM";
  ChainId[ChainId["ARBITRUM_GOERLI"] = 421613] = "ARBITRUM_GOERLI";
  ChainId[ChainId["AVALANCHE"] = 43114] = "AVALANCHE";
  ChainId[ChainId["FUJI"] = 43113] = "FUJI";
  ChainId[ChainId["POLYGON"] = 137] = "POLYGON";
  ChainId[ChainId["POLYGON_MUMBAI"] = 80001] = "POLYGON_MUMBAI";
  return ChainId;
}({});
export const pgnTestnet = {
  id: 58008,
  name: "PGN Testnet",
  network: "pgn testnet",
  iconUrl: PublicGoodsNetworkIcon,
  nativeCurrency: {
    decimals: 18,
    name: "Ether",
    symbol: "ETH"
  },
  rpcUrls: {
    default: {
      http: ["https://sepolia.publicgoods.network"]
    },
    public: {
      http: ["https://sepolia.publicgoods.network"]
    }
  },
  blockExplorers: {
    default: {
      name: "pgnscan",
      url: "https://explorer.sepolia.publicgoods.network"
    }
  },
  testnet: true
};
export const pgn = {
  id: 424,
  name: "PGN",
  network: "pgn",
  iconUrl: PublicGoodsNetworkIcon,
  nativeCurrency: {
    decimals: 18,
    name: "Ether",
    symbol: "ETH"
  },
  rpcUrls: {
    default: {
      http: ["https://rpc.publicgoods.network"]
    },
    public: {
      http: ["https://rpc.publicgoods.network"]
    }
  },
  blockExplorers: {
    default: {
      name: "pgnscan",
      url: "https://explorer.publicgoods.network"
    }
  }
};